import { FC } from 'react'
import { DropdownField } from 'components/Forms/DropdownListField/DropdownField/Field'
import { Loader } from 'components/Loader/Loader'

import styles from './CountryCodeSelectorLoader.module.scss'

export const CountryCodeSelectorLoader: FC = () => (
  <div className={styles.CountryCodeSelectorLoader}>
    <DropdownField
      onClick={() => null}
      selected={<Loader />}
      type="dark"
      isPlaceholder={false}
      rotateArrow={false}
    />
  </div>
)
